import React, { Component } from "react";
import '../rnr.css';
import Table from 'react-bootstrap/Table';

class Resources extends Component {
  
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
            <h4 className="mt-3">Resources</h4><br />
            <Table size="sm" borderless="true">
                <tbody>
                    <tr>
                        <td colSpan="2"><h5>Social Media</h5></td>
                    </tr>
                    <tr>
                        <td style={{width: "25%"}}><strong><a className="rnr" href="https://twitter.com/hashtag/ExtremeWeather" rel="noopener noreferrer" target="_blank">#ExtremeWeather</a></strong></td>
                        <td style={{width: "75%"}}>
                          <p>Climate change is shaping weather around the world, fueling an increased number of extreme weather events and a growing number of people are taking to Twitter to see and talk about what's happening.</p>
                          <p>Twitter has collaborated with their partners and developers to visualize how Twitter conversation shifts as <a className="rnr" href="https://twitter.com/hashtag/ExtremeWeather" rel="noopener noreferrer" target="_blank">#ExtremeWeather</a> events occur across the globe, and specifically in Texas, Jakarta, Australia, and Japan.
                               Explore these visualizations by <a className="rnr" href="https://developer.twitter.com/en/use-cases/build-for-good/extreme-weather" rel="noopener noreferrer" target="_blank">clicking here</a>.</p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2"><h5>Websites</h5></td>
                    </tr>
                    <tr>
                        <td style={{width: "25%"}}><strong><a className="rnr" href="https://data.gov.sg/group/environment/" rel="noopener noreferrer" target="_blank">Data.gov.sg Environment</a></strong></td>
                        <td style={{width: "75%"}}>
                        <p>
                        <a className="rnr" href="https://data.gov.sg/" rel="noopener noreferrer" target="_blank">Data.gov.sg</a> was first launched in 2011 as the government's one-stop portal to its publicly-available datasets from 70 public agencies. To date, more than 100 apps have been created using the government’s open data.
                        </p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{width: "25%"}}><strong><a className="rnr" href="https://kh.asfi.asia/" rel="noopener noreferrer" target="_blank">ASFI Knowledge Hub</a></strong></td>
                        <td style={{width: "75%"}}>
                        <p>
                            The <a className="rnr" href="https://www.asfi.asia/" rel="noopener noreferrer" target="_blank">Asia Sustainable Finance Initiative</a> (ASFI) has consolidated the most relevant, science-based sustainable finance resources into
                             a single, searchable <a className="rnr" href="https://kh.asfi.asia/" rel="noopener noreferrer"target="_blank">database</a>. Their Knowledge Partners ensure that ASFI’s members have access to the latest global thought leadership 
                             and dialogue on the rapidly evolving field of sustainability and sustainable finance around the world.
                        </p>
                        <p>The ASFI is a multi-stakeholder forum, incubated by WWF Singapore that aims to harness and amplify the 
                            power of the finance sector to create low-carbon, climate resilient economies that deliver on the Sustainable Development Goals (SDGs) and the Paris 
                            Agreement. This will ensure that economic and social development is achieved while preserving the natural capital on which all societies depend, 
                            and support the urgent transition to sustainable food, energy, transport, and infrastructure systems.
                        </p>
                        <p>Based in <b>Singapore</b>, ASFI brings together global industry, academic, and science-based resources to support financial institutions in the region
                             in implementing Environmental, Social, and Governance (ESG) best practices. As Singapore is a conduit for financial flows into Asia, 
                             the lending and investment decisions taken by financial institutions based here will have a significant impact on the region's contribution 
                             to a 1.5-degree world and its climate resilience. 
                        </p>
                        </td>
                    </tr>
                </tbody>
           </Table>
        </div>
      </main>
    );
  }
}
 
export default Resources;